import { Component, ojs, app, v, eData, payload, state } from "modular-openscriptjs";
import { dom } from "../../fotastart";
import { monetary, either, oneOf } from "../../helpers";
import { uc, gc } from "../../declarations";
import CheckYesno from "../Blocks/CheckYesno";

const h = app("h");
const broker = app("broker");
const route = app("router");
const $e = app("$e");

ojs(CheckYesno);

export default class MpesaForm extends Component {
	alreadyPaid = state(null);
	render(...args) {
		return h.div(
			h.h5(
				{ class: "fw-bold mb-3 text-secondary" },
				"Enter M-Pesa Details"
			),

			h.div(
				{ class: "card border-0 shadow-sm rounded-4" },
				h.div(
					{ class: "card-body p-4" },
					h.form(
						h.div(
							{ class: "mb-4 text-center" },
							h.small(
								{ class: "text-muted text-uppercase fw-bold" },
								"Amount to Pay"
							),
							h.h2(
								{ class: "text-success fw-bold mt-1" },
								v(uc.currentPaymentAmount, (amount) => {
									let v = amount.value;
									return monetary(v, route.params.currency);
								})
							)
						),

						h.div(
							{ class: "mb-4" },
							h.label(
								{ class: "form-label fw-bold text-secondary small mb-3 d-block text-center" },
								"HAVE YOU ALREADY MADE THIS PAYMENT?"
							),
							v(this.alreadyPaid, (ap) => {
								const isPaid = ap.value;
								return h.div(
									{ class: "d-flex gap-2 justify-content-center" },
									h.button(
										{
											type: "button",
											class: `btn btn-sm rounded-3 px-4 fw-semibold d-inline-flex gap-2  align-items-center justify-content-center ${isPaid === false ? 'btn-success text-white' : 'btn-outline-secondary'}`,
											onclick: this.method("setAlreadyPaid", [false]),
										},
										h.i({ class: "bi bi-x-circle me-1" }),
										h.span("No")
									),
									h.button(
										{
											type: "button",
											class: `btn btn-sm rounded-3 px-4 fw-semibold d-inline-flex gap-2 align-items-center justify-content-center ${isPaid === true ? 'btn-warning text-dark' : 'btn-outline-secondary'}`,
											onclick: this.method("setAlreadyPaid", [true]),
										},
										h.i({ class: "bi bi-check-circle me-1" }),
										h.span("Yes")
									)
								);
							})
						),

						v(this.alreadyPaid, (ap) => {
							const isPaid = ap.value;
							if (isPaid === null) {
								return h._();
							}
							return h.div(
								h.div(
									{ class: "form-group mb-4" },
									h.label(
										{
											for: "mpesa-payment-number",
											class: "form-label fw-bold text-secondary small",
										},
										isPaid ? "MPESA SMS" : "PHONE NUMBER"
									),
									h.div(
										{ class: "input-group input-group-lg" },
										h.span(
											{
												class: "input-group-text bg-light border-0 text-muted",
											},
											h.i({ class: isPaid ? "bi bi-chat-left-text" : "bi bi-phone" })
										),
										h.input({
											type: "text",
											class: "form-control bg-light border-0 fw-bold",
											id: "mpesa-payment-number",
											aria_describedby: "payment-help",
											placeholder: isPaid ? "M-Pesa SMS here" : "e.g. 0712345678",
											value: isPaid ? "" : oneOf(gc?.user?.value?.phone, ""),
											oninput: this.method(
												"parseTransactionId",
												"${this}"
											),
										})
									),
									h.small(
										{
											id: "payment-help",
											class: "form-text text-muted mt-2 d-block",
										},
										h.i({ class: "bi bi-info-circle me-1" }),
										isPaid 
											? "Paste the M-Pesa SMS message above." 
											: "M-Pesa will prompt this number"
									)
								),

								h.div(
									{ class: "form-check mb-4" },
									h.input({
										type: "checkbox",
										class: "form-check-input",
										id: "terms-and-condition-mpesa",
										checked: either(
											localStorage.getItem("paymentTc") == 1,
											true
										),
									}),
									h.label(
										{
											class: "form-check-label text-muted small",
											for: "terms-and-condition-mpesa",
										},
										"I agree to Carata ",
										h.a(
											{
												href: "https://carata.co/terms-and-conditions/",
												target: "_blank",
												class: "text-decoration-none",
											},
											"Terms and Conditions"
										)
									)
								),

								h.button(
									{
										type: "button",
										class: "btn btn-success w-100 rounded-pill py-3 fw-bold shadow-sm",
										onclick: this.method("submit"),
									},
									"Pay With M-Pesa"
								)
							);
						})
					)
				)
			)
		);
	}

	submit() {
		let number = dom.id("mpesa-payment-number");
		let tc = dom.id("terms-and-condition-mpesa");
		let method = "mpesa";

		let meta = {};
		let amount = null;
		if (route.qs.has("editable")) {
			amount = uc.currentPaymentAmount.value;
		}

		for (let [k, v] of route.qs.entries()) {
			meta[k] = v;
		}

		meta.method = method;

		broker.broadcast(
			$e.payment.needs.creation,
			eData(meta, {
				paymentData: {
					number: number?.value,
					payment_type: "credit",
					type: "phone",
				},
				tc: tc?.checked ?? false,
				method,
				amount,
			})
		);
	}

	parseTransactionId(elem) {
		if (!elem?.value) return;

		elem.value = elem.value.split(/\s+/g)[0];
	}

	setAlreadyPaid(val) {
		this.alreadyPaid.value = val;
	}
}
